import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/view/index'
import Login from '@/view/login'
import Register from '@/view/register'
import HomeBase from '@/view/home_base'
import SingleHome from '@/view/single_home'

import Down from '@/view/down'

import Cycle from '@/view/cycle'
import Single from '@/view/single'
import Import from '@/view/import'
import Prediction from '@/view/prediction'
import PredictionCar from '@/view/prediction_car'
import PredictionStation from '@/view/prediction_station'
import SourceDataPre from '@/view/source_data_pre'
import Setting from '@/view/setting'
import Cars from '@/view/cars'
import CarRoute from '@/view/car_route'
import Output from '@/view/output'
import SourceData from '@/view/source_data'

import ErrorPage from '@/view/error'

import Electricity from '@/view/ele/index'
import EleImport from '@/view/ele/ele_import'
import EleCase from '@/view/ele/ele_case'
import EleResult from '@/view/ele/ele_result'
import EleSourceData from '@/view/ele/ele_source_data'
import EleCompare from '@/view/ele/ele_compare'

import Tobacco from '@/view/tobacco'
import ImportTo from '@/view/tobacco/import_to'
import SourceDataTo from '@/view/tobacco/source_data_to'
import PredictionTo from '@/view/tobacco/prediction_to'
import SettingTo from '@/view/tobacco/setting_to'
import CarsTo from '@/view/tobacco/cars_to'
import CarRouteTo from '@/view/tobacco/car_route_to'
import OutputTo from '@/view/tobacco/output_to'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: Index,
    children: [{
      path: 'down',
      name: 'down',
      component: Down
    }]
  },
  {
    path: '/single_home',
    name: 'single_home',
    redirect: {
      name: 'single.single'
    },
    component: SingleHome,
    children: [{
      path: 'single',
      name: 'single.single',
      component: Single,
      children: [{
        path: 'prediction',
        name: 'single.prediction',
        component: Prediction
      },
      {
        path: 'prediction_car',
        name: 'single.prediction_car',
        component: PredictionCar
      },
      {
        path: 'source_data_pre',
        name: 'single.source_data_pre',
        component: SourceDataPre
      },
      {
        path: 'prediction_station',
        name: 'single.prediction_station',
        component: PredictionStation
      }]
    }]
  },
  {
    path: '/electricity',
    name: 'ele',
    component: Electricity,
    children: [{
      path: 'ele_import',
      name: 'ele_import',
      component: EleImport
    },
    {
      path: 'ele_case',
      name: 'ele_case',
      component: EleCase
    },
    {
      path: 'ele_result',
      name: 'ele_result',
      component: EleResult
    },
    {
      path: 'ele_source_data',
      name: 'ele_source_data',
      component: EleSourceData
    },
    {
      path: 'ele_compare',
      name: 'ele_compare',
      component: EleCompare
    }]
  },
  {
    path: '/tobacco',
    name: 'tobacco',
    component: Tobacco,
    children: [{
      path: 'import_to',
      name: 'import_to',
      component: ImportTo
    },
    {
      path: 'source_data_to',
      name: 'source_data_to',
      component: SourceDataTo
    },
    {
      path: 'prediction_to',
      name: 'prediction_to',
      component: PredictionTo
    },
    {
      path: 'setting_to',
      name: 'setting_to',
      component: SettingTo
    },
    {
      path: 'cars_to',
      name: 'cars_to',
      component: CarsTo
    },
    {
      path: 'car_route_to',
      name: 'car_route_to',
      component: CarRouteTo
    },
    {
      path: 'output_to',
      name: 'output_to',
      component: OutputTo
    }]
  },
  {
    path: '/home',
    name: 'home_base',
    component: HomeBase,
    children: [{
      path: 'cycle',
      name: 'cycle',
      component: Cycle,
      children: [{
        path: 'import',
        name: 'import',
        component: Import
      },
      {
        path: 'source_data',
        name: 'source_data',
        component: SourceData
      },
      {
        path: 'setting',
        name: 'setting',
        component: Setting
      },
      {
        path: 'cars',
        name: 'cars',
        component: Cars
      },
      {
        path: 'car_route',
        name: 'car_route',
        component: CarRoute
      }]
    },
    {
      path: 'single',
      name: 'single',
      component: Single,
      children: [{
        path: 'prediction',
        name: 'prediction',
        component: Prediction
      },
      {
        path: 'prediction_car',
        name: 'prediction_car',
        component: PredictionCar
      },
      {
        path: 'source_data_pre',
        name: 'source_data_pre',
        component: SourceDataPre
      },
      {
        path: 'prediction_station',
        name: 'prediction_station',
        component: PredictionStation
      }]
    },
    {
      path: 'output',
      name: 'output',
      component: Output
    },
    {
      path: 'error',
      name: 'error',
      component: ErrorPage
    }]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js